module.exports = __webpack_public_path__ + "static/media/home_page_publishing_background@768.3ec96021.png";